module.exports = __webpack_public_path__ + "images/420b408532eea877edb1424444e0658a.svg";